<template>
  <j-editable-table
    ref="sortTable"
    rowNumber
    dragSort
    :columns="columns"
    :dataSource="dataSource"
    :sortInsertDown="false"
  />
</template>

<script>
import { FormTypes } from '@/utils/JEditableTableUtil'
export default {
  props: {
    // 需要排序的數據
    sortItem: {
      type: Object,
    },
  },
  computed: {
    language() {
      return this.$store.getters.language
    },

    columns() {
      if (this.language) {
        return [
          {
            title: this.language['system.departSigne.signeNodePerson'],
            key: 'userNames',
            type: FormTypes.normal,
            width: '180px',
          },
        ]
      }
    },
  },
  data() {
    return {
      dataSource: [],
    }
  },
  watch: {
    sortItem: {
      immediate: true,
      handler(val) {
        if (val) {
          let keys = val.userCodes.split(',')
          console.log('keys= ', keys)
          let values = val.userNames.split(',')
          let list = []
          keys.forEach((key, index) => {
            list.push({ id: key, userNames: values[index] })
          })
          this.dataSource = list
        } else {
          this.dataSource = []
        }
      },
    },
  },

  methods: {
    handleOk() {
      let list = this.$refs.sortTable.getValuesSync({ validate: false }).values
      const userCodes = list.map((item) => item.id).join()
      const userNames = list.map((item) => item.userNames).join()
      this.$emit('handleSortOk', this.sortItem.id, userCodes, userNames)
    },
  },
}
</script>

<style>
</style>